// globals.ts
import { Injectable } from '@angular/core';

@Injectable()
export class Globals {
  // serverURL: string = 'http://racms.linkdood.com/pmms';
  // serverURL: string = 'http://192.168.0.145:8181/pmms';
}